import { CanMatchFn } from '@angular/router';

/**
 * Link guard
 * Check if the route is a link
 *
 * @param route
 * @param segments
 * @returns
 */
export const linkGuard: CanMatchFn = (route, segments) => {
    if (segments.length > 1) {
        return false;
    }
    const [segment] = segments;

    if (segment.path.length === 10) {
        return true;
    }

    return false;
};
